import { useCallback } from 'react';
import { useStore, StoreTypes } from 'context';
import * as types from 'constants/actionTypes';
import useModal from 'components/common/Modal/useModal';
import { ModalComponentGenerator, ModalComponentType } from 'components/common/Modal/ModalComponentGenerator';

export const useStickyNoteCommand = () => {
    const [_, globalDispatch] = useStore(StoreTypes.global);

    const [, { openModal, setModalComponents }] = useModal();
    const execute = useCallback(async ({ canvasSVGObject }) => {
        try {
            const component = ModalComponentGenerator.generate(ModalComponentType.StickyNote, { canvasSVGObject });
            setModalComponents(component);
            openModal();
        } catch (e) {
            console.error('InternalWindowCommand execute error', e);
        }
    }, [openModal, setModalComponents]);

    const hoverExecute = useCallback(async ({ canvasSVGObject }) => {

        globalDispatch({
            type:types.SET_TOOLTIP,
            payload:{
                canvasSVGObject
            }
          })
    }, []);

    const closeHover = useCallback(() => {
        globalDispatch({
            type:types.HIDE_TOOLTIP,
        })
    }
    , []);

    return { execute, hoverExecute, closeHover };
};
